import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { fmtDate } from "../../lib/format";

export default function AdminCustomers() {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/admin/customers").then(({ data }) => setUsers(data));
  }, []);

  return (
    <div data-testid="admin-customers">
      <div className="overline mb-2">{t("admin.customers")}</div>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tightest mb-8">{t("admin.customers")}</h1>
      <div className="card-soft overflow-auto !rounded-3xl">
        <table className="w-full text-sm" data-testid="admin-customers-table">
          <thead className="bg-cobalt-50 text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left px-4 py-3">{t("common.email")}</th>
              <th className="text-left px-4 py-3">{t("common.name")}</th>
              <th className="text-left px-4 py-3">{t("admin.orderCount")}</th>
              <th className="text-left px-4 py-3">{t("admin.esimCount")}</th>
              <th className="text-left px-4 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-ink-100">
                <td className="px-4 py-3">{u.email}</td>
                <td className="px-4 py-3">{u.name || "—"}</td>
                <td className="px-4 py-3 font-semibold">{u.orders_count}</td>
                <td className="px-4 py-3 font-semibold">{u.esims_count}</td>
                <td className="px-4 py-3 text-ink-500">{fmtDate(u.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
